import * as sdk from './sdk';
import queryString from 'query-string';
import * as crossPopup from '../functions/crossPopup';

export const store = {
    computed: {
        toolbarTitle() {
            return this.$store.state.toolbarTitle;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        isGuest() {
            return !this.userInfo;
        },
        isLogged() {
            return !!this.userInfo;
        },
        isEditorAccount() {
            return !!this.userInfo.parentId;
        },
        isAndroidOnly() {
            return !!this.userInfo.androidOnly && !this.userInfo.iosOnly;
        },
        isIOSOnly() {
            return !!this.userInfo.iosOnly && !this.userInfo.androidOnly;
        },
        isAndroidExtBannerEnabled() {
            return !!this.userInfo.androidExtBannerEnabled;
        },
        isIOSExtVisualNotificationEnabled() {
            return this.userInfo && this.userInfo.secondLogoEnabled;
        },
        isStudioAndUploadDisabled() {
            return this.isUploadDisabled && this.isStudioDisabled;
        },
        customMods() {
            return this.$store.state.customMods;
        },
        isStudioDisabled() {
            return this.isEditorAccount || this.userInfo.disableStudio;
        },
        isModNewsEnabled() {
            return this.userInfo && (this.userInfo.enableModNews || ['flow_demo1@pressenger.com', 'egyeteam@pressenger.com'].includes(this.userInfo.name.toLocaleLowerCase()));
        },
        isUploadDisabled() {
            return this.isEditorAccount;
        },
        requestedMode() {
            if (this.$route.query.requestedMode) {
                return this.$route.query.requestedMode;
            }
            const parsed = queryString.parse(location.search);
            return parsed.requestedMode || null;
        },
        isPushwize() {
            return this.requestedMode && this.requestedMode.indexOf('pushwize') === 0;
        },
        isFinestrat() {
            if (this.userInfo && ['finestrat@pressenger.com'].includes(this.userInfo.name.toLocaleLowerCase())) {
                return true;
            }
            return false;
        },
        isInflugamers() {
            return this.requestedMode && this.requestedMode.indexOf('influgamers') === 0;
        },
        enabledSysMenus() {
            return this.userInfo?.menuItems || ['toolbox', 'performance', 'profile', 'gallery'];
        },
    },
    methods: {
        logout() {
            return new Promise((resolve, reject) => {
                return sdk.accessManagement.logout().then(() => {
                    crossPopup.closeAllInstances();
                    document.body.className = '';
                    this.setUserInfo(null);
                    sdk.setRecipientList(null);
                    resolve();
                }).catch(e => {
                    reject(e)
                });
            });
        },
        setUserInfo(uinfo) {
            this.$store.dispatch('update', {
                userInfo: uinfo,
            });
        },
        setToolbarTitle(title) {
            this.$store.dispatch('update', {
                toolbarTitle: title,
            });
        },
        setCustomMods(mods) {
            this.$store.dispatch('update', {
                customMods: mods,
            });
        },
        setAppLayoutMode(mode) {
            this.$store.dispatch('update', {
                mode,
            });
        },
    },
};
